import NBType, { InferType } from '@netbase/nb-type'
import PivotSchema from './PivotSchema'

const PivotResultSchema = NBType.object().shape('PivotResultSchema', {
  /* @prop */
  crossTabs: NBType.array().of(PivotSchema)
  /* END */
})
export default PivotResultSchema
export type PivotResult = InferType<typeof PivotResultSchema>
// RESERVE BELOW
